import {Elements, ExpressCheckoutElement} from '@stripe/react-stripe-js'
import {registerExpressPaymentMethod} from '@woocommerce/blocks-registry';
import PreviewComponent from './preview';
import {
    initStripe as loadStripe,
    getSettings, isCartPage, isCheckoutPage, isFieldRequired, mapLineItems,
} from '../util';
import {
    useCreatePaymentMethod,
    useExpressCheckout,
    useProcessCheckoutSuccess,
    useProcessExpressCheckoutError
} from "../hooks";

const getData = getSettings('stripe_link_checkout_data');

let cachedPromise = null;

const Link = (props) => {
    const {
        billing
    } = props;

    const {
        cartTotal,
        currency
    } = billing;

    let options = {
        mode: 'payment',
        paymentMethodCreation: 'manual',
        currency: currency?.code?.toLowerCase(),
        appearance: {
            variables: {
                borderRadius: getData('button').radius
            }
        },
        ...getData('elementOptions')
    }
    if (0 >= cartTotal.value) {
        options = {...options, mode: 'setup'}
    }
    if (['payment', 'subscription'].includes(options.mode)) {
        options.amount = cartTotal.value;
    }
    return (
        <Elements
            stripe={loadStripe}
            options={options}>
            <LinkExpressCheckout {...props}/>
        </Elements>
    )
}

const LinkExpressCheckout = (props) => {
    const name = 'stripe_link_checkout_express';
    const gatewayId = getData('gatewayId');
    const buttonHeight = Math.max(40, Math.min(55, parseInt(getData('button').height)));
    const {
        onClick,
        onClose,
        onError,
        billing,
        onSubmit,
        cartData,
        emitResponse,
        shippingData,
        eventRegistration,
        activePaymentMethod
    } = props;

    const {
        cartTotal,
        billingAddress
    } = billing;

    const {
        onCheckoutFail,
        onCheckoutSuccess
    } = eventRegistration;

    const elementType = 'expressCheckout';

    const total = parseInt(cartTotal.value);

    const {
        needsShipping,
        shippingAddress
    } = shippingData;

    const {extensions} = cartData;
    const {lineItems} = extensions?.wc_stripe?.cart || {};

    const options = {
        buttonHeight,
        paymentMethods: {
            applePay: 'never',
            googlePay: 'never',
            amazonPay: 'never',
            paypal: 'never',
            klarna: 'never',
            link: 'auto'
        },
        emailRequired: isFieldRequired('email'),
        phoneNumberRequired: isFieldRequired('phone'),
        billingAddressRequired: true,
        shippingAddressRequired: needsShipping
    };

    const {
        events
    } = useCreatePaymentMethod({
        name,
        gatewayId,
        emitResponse,
        billingAddress,
        shippingAddress,
        eventRegistration,
        shouldSavePayment: false,
        activePaymentMethod
    });

    const {
        onConfirm,
        onButtonClick,
        onShippingRateChange,
        onShippingAddressChange,
    } = useExpressCheckout({
        name,
        total,
        events,
        onClick,
        lineItems: mapLineItems(lineItems),
        shippingData,
        paymentMethod: gatewayId,
        activePaymentMethod
    });

    useProcessCheckoutSuccess({
        name,
        elementType,
        emitResponse,
        billingAddress,
        onCheckoutSuccess,
        activePaymentMethod,
    });

    useProcessExpressCheckoutError({
        name,
        onError,
        emitResponse,
        onCheckoutFail,
        activePaymentMethod
    });

    return (
        <ExpressCheckoutElement
            options={options}
            onClick={(event) => {
                onButtonClick(event);
            }}
            onCancel={(event) => {
                onClose();
            }}
            onConfirm={(event) => {
                onConfirm(event);
                onSubmit();
            }}
            onLoadError={error => {
                console.log(error);
            }}
            onShippingAddressChange={onShippingAddressChange}
            onShippingRateChange={onShippingRateChange}
        />
    )
}

registerExpressPaymentMethod({
    name: 'stripe_link_checkout_express',
    gatewayId: getData('gatewayId'),
    paymentMethodId: getData('gatewayId'),
    canMakePayment: (props) => {
        const {
            cart
        } = props;
        if (isCartPage() && !getData('cartCheckoutEnabled')) {
            return false;
        }
        if (isCheckoutPage() && !getData('expressCheckoutEnabled')) {
            return false;
        }
        if (cachedPromise !== null) {
            return cachedPromise;
        }

        let currency = cart.cartTotals.currency_code?.toLowerCase();
        if (!currency || currency?.length < 3) {
            currency = getData('currency')?.toLowerCase();
        }
        const total = parseInt(cart.cartTotals.total_price);
        cachedPromise = new Promise(resolve => {
            return loadStripe.then(stripe => {
                let options = {
                    mode: 'payment',
                    currency,
                }
                if (0 >= total) {
                    options = {...options, mode: 'setup'}
                }
                if (['payment', 'subscription'].includes(options.mode)) {
                    options.amount = total;
                }

                const element = stripe.elements(options);

                const expressCheckoutElement = element.create('expressCheckout');
                expressCheckoutElement.on('ready', ({availablePaymentMethods}) => {
                    const {link = false} = availablePaymentMethods || {};
                    expressCheckoutElement.unmount();
                    div.remove();
                    resolve(link);
                });
                expressCheckoutElement.on('loaderror', () => {
                    div.remove();
                    resolve(false);
                });

                const div = document.createElement('div');
                div.style.display = 'none';
                document.querySelector('body').appendChild(div);

                expressCheckoutElement.mount(div);

            })
        });
        return cachedPromise;
    },
    content: <Link/>,
    edit: <PreviewComponent/>,
    supports: {
        showSavedCards: getData('showSavedCards'),
        showSaveOption: getData('showSaveOption'),
        features: getData('features')
    }
});